import styled from "styled-components";
import { palette } from "styled-theme";

const ContentSiderWrapper = styled.div`
  .ant-layout-sider {
    background-color: ${palette("surfaceColor", 0)};
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    margin: 10px 0 0 0;
    position: sticky;
    top: 10px;
    max-height: calc(100vh - 245px);
    overflow: auto;
    nav {
      height: 100%;
    }
    ul {
      height: 100%;
      padding: 20px;
      border: none;
      border-radius: 5px;
    }
  }
`;

export default ContentSiderWrapper;
